import Agradecimiento from './components/Agradecimiento.js';
import Inicio from './components/Inicio.js';
import {Route, BrowserRouter, Redirect} from "react-router-dom";
import './App.css';

function App() {
  // <Route exact path="/login" component={Login}/>  
  //<PrivateRoute exact path="/ayuntamientos" component={Inicio } />
  return (
    <BrowserRouter basename={'/voluminosos'}> 
    <div className="content">
      <Route exact path="/" render={() => {
                    return (<Redirect to="/solicitud" />)
                }} />
      <Route exact path="/solicitud" component={Inicio } />  
      <Route exact path="/gracias" component={Agradecimiento} />
      <Route exact path="/pruebas_desarrollo"  
        render={(props) => (
          <Inicio {...props} ayuntamientos={true} />
  )}/>  
   
      
    </div>
  </BrowserRouter>    
  )
}

export default App;
